// extracted by mini-css-extract-plugin
module.exports = {"link":"_3168d1cb link b","srOnly":"_53b25bfd"};